import { useContext, useMemo, useRef, useState, useEffect } from 'react';
import InputText from '../../../components/inputComponents/InputText';
import ValidateService from '../../../services/ValidateService';
import { GlobalContext, ModalContext } from '../../../components/contexts';
import ConsultDetailContent from './ConsultDetailContent';
import { useLocation } from 'react-router-dom';
import ExpertConsultDetailController from '../../../controllers/expert/consult/ExpertConsultDetailController';

const ExpertConsultDetail = () => {
  const location = useLocation();
  const [svcObj, setSvcObj] = useState(location.state?.rowData);
  const store = useContext(GlobalContext);
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const gridRef = useRef(null);
  const [detailList, setDetailList] = useState([]);

  const rsltList = useRef([]);
  const cnsltList = useRef([]);

  const onChangeRslt = (menuIndex, index, model, value, tables) => {
    const updatedTables = tables.map((table, i) => {
      if (i === index) {
        return {
          ...table,
          valueObj: {
            ...table.valueObj,
            [model]: value,
            index: index,
          },
        };
      }
      return table;
    });
    cnsltList.current = updatedTables;

    for (let i = 0; i < updatedTables.length; i++) {
      const transformedData = updatedTables.map(item => ({
        ...item.valueObj,
        key: item.key,
        menuIndex: item.menuIndex,
      }));

      const filteredData = updatedTables.filter(
        item => item.valueObj.menuIndex === menuIndex
      );

      rsltList.current[menuIndex].improvementList = [];
      rsltList.current[menuIndex].improvementList.push(...transformedData);
    }
  };

  const controller = useMemo(() => {
    return new ExpertConsultDetailController(
      store,
      modalService,
      validateService,
      svcObj,
      {
        detailList,
        setDetailList,
      },
      rsltList,
      cnsltList
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    document.title = '전문가 컨설팅 상세';
    controller.fnGetExpertConsultDetail(svcObj);
  }, []);

  const evlArtclNmList = [
    'neck',
    'trunk',
    'leg',
    'upperArm',
    'lowerArm',
    'wrist',
    'add',
  ];

  const initResultList = [];
  for (let i = 0; i < evlArtclNmList.length; i++) {
    initResultList.push({
      seq: i,
      evlArtclNm: evlArtclNmList[i],
      poseInfo: null,
      addInfo1: null,
      addInfo2: null,
      exprtScr: null,
      owasScr: null,
      rulaScr: null,
      rebaScr: null,
    });
  }

  // detailList 변경 감지 후 rsltList 동기화
  useEffect(() => {
    const newWorkMenuArr = [];
    for (let i = 0; i < detailList.length; i++) {
      if (!rsltList.current[i]) {
        rsltList.current[i] = { index: i, ...detailList[i] };
      }
      if (rsltList.current[i].resultList.length === 0) {
        rsltList.current[i].resultList = initResultList;
      }

      // 작업 메뉴 구성
      newWorkMenuArr.push({
        name: detailList[i].workNm,
        content: (
          <ConsultDetailContent
            key={detailList[i].exprtAnlsDtlId}
            rslt={rsltList.current[i]}
            onChangeRslt={onChangeRslt}
            svcObj={svcObj}
            modalService={modalService}
          />
        ),
      });
    }
    setWorkMenuArr(newWorkMenuArr);
  }, [detailList]);

  // 작업 menu 기능 구현
  const [currentWorkMenu, setCurrentWorkMenu] = useState(0);
  const [workMenuArr, setWorkMenuArr] = useState([]);

  const selectWorkMenuHandler = index => {
    setCurrentWorkMenu(index);
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">전문가 컨설팅 상세</h2>
      </div>
      <div className="tbl-wrap">
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">공정</th>
              <td>
                <div className="input-group">
                  <input
                    aria-label="공정명 입력"
                    type="text"
                    className="form-control md"
                    placeholder="공정명 입력"
                    value={svcObj.taskNm}
                    readOnly
                  />
                  <button
                    type="button"
                    className="btn sm"
                    onClick={() => {
                      modalService.openModal('AnalyzeBasicSurvey', svcObj);
                    }}
                  >
                    기본 조사표
                  </button>
                  <button
                    type="button"
                    className="btn sm"
                    onClick={() => {
                      modalService.openModal('AnalyzeSurveySymptom', svcObj);
                    }}
                  >
                    증상 조사표
                  </button>

                  {(svcObj.cnsltSttsCd === 'CNSLT01' &&
                    store.store?.authrtId === 'EX') ||
                  (svcObj.cnsltSttsCd === 'CNSLT02' &&
                    store.store?.authrtId != 'EX') ||
                  (svcObj.cnsltSttsCd === 'CNSLT03' &&
                    store.store?.authrtId === 'EX') ? (
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => controller.fnSave('Y')}
                    >
                      임시저장
                    </button>
                  ) : null}

                  {store.store?.authrtId === 'EX' &&
                  svcObj.cnsltSttsCd === 'CNSLT01' ? (
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => controller.fnSave('CNSLT02')}
                    >
                      컨설팅등록
                    </button>
                  ) : null}

                  {(store.store?.authrtId === 'ME' ||
                    store.store?.authrtId === 'MU') &&
                  svcObj.cnsltSttsCd === 'CNSLT02' ? (
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => controller.fnUploadVdo()}
                    >
                      검증영상업로드
                    </button>
                  ) : null}

                  {(store.store?.authrtId === 'ME' ||
                    store.store?.authrtId === 'MU') &&
                  svcObj.cnsltSttsCd === 'CNSLT02' &&
                  detailList?.[0]?.vldAplyStts === 'C' ? (
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => controller.fnSave('CNSLT03')}
                    >
                      수행사항등록
                    </button>
                  ) : null}
                  {store.store?.authrtId === 'EX' &&
                  svcObj.cnsltSttsCd === 'CNSLT03' ? (
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => controller.fnSave('CNSLT04')}
                    >
                      수행여부등록
                    </button>
                  ) : null}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="tbl-wrap">
        <div className="work-tabs-wrap">
          <ul id="workMenu" className="nav-tabs">
            {detailList.map((el, index) => (
              <li
                key={index}
                className={index === currentWorkMenu ? 'tabs on' : 'tabs'}
                onClick={() => selectWorkMenuHandler(index)}
              >
                <a>{el.workNm}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {workMenuArr[currentWorkMenu]?.content}
    </>
  );
};

export default ExpertConsultDetail;
